import { render, staticRenderFns } from "./IconClockSolid.vue?vue&type=template&id=a5ef1e0c"
import script from "./IconClockSolid.vue?vue&type=script&lang=js"
export * from "./IconClockSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports